module.exports = __webpack_public_path__ + "static/media/38.2877f807.ogg";